import {Component, OnInit, ChangeDetectionStrategy, ChangeDetectorRef} from '@angular/core';
import { DynamicModalAbstractComponent } from '../../../classes/dynamic-modal-abstract-component';
import { DynamicModalLoaderService } from '../../../services/dynamic-modal-loader.service';

@Component({
  selector: 'gen-confirm-modal',
  templateUrl: './confirm-modal.component.html',
  styleUrls: ['./confirm-modal.component.scss'],
  changeDetection: ChangeDetectionStrategy.Default
})
export class ConfirmModalComponent extends DynamicModalAbstractComponent implements OnInit {
  public content: string;
  public contentParams: string;

  constructor(modalLoaderService: DynamicModalLoaderService,private _changeDetector: ChangeDetectorRef) {
    super(modalLoaderService);
  }

  onNext(payload): void {
    this.content = payload && payload['content'] || '';
    this.contentParams = payload && payload['params'] || '';
    this._changeDetector.detectChanges();
  }

  onError(error): void {
  }

  onComplete(): void {
  }


  ngOnInit() {
  }
}
